var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipped(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2103_10184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.066 77.5711C60.5686 77.5711 77.9999 60.2863 77.9999 38.9644C77.9999 17.6425 60.5686 0.357666 39.066 0.357666C17.5634 0.357666 0.13208 17.6425 0.13208 38.9644C0.13208 60.2863 17.5634 77.5711 39.066 77.5711Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2103_10184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3858 30.3162C24.3858 30.3162 23.1874 26.1467 19.3925 28.3969C15.5977 30.581 20.5909 39.251 22.6548 39.1186C24.7187 38.9863 25.6508 38.1259 25.6508 38.1259L24.3858 30.3162Z",
    fill: "#E1AC85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7464 30.3162C53.7464 30.3162 54.9448 26.1467 58.7397 28.3969C62.5346 30.581 57.5413 39.251 55.4774 39.1186C53.4135 38.9863 52.4814 38.1259 52.4814 38.1259L53.7464 30.3162Z",
    fill: "#E1AC85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2804 58.5766C43.0275 57.981 43.6267 49.5757 43.6267 49.5757H39.0995H34.5723C34.5723 49.5757 35.1715 57.9148 24.9186 58.5766C14.6657 59.1723 7.87487 63.8713 8.0746 77.5713H39.0995H70.1244C70.3241 63.8713 63.5333 59.1723 53.2804 58.5766Z",
    fill: "#EABF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.098 55.6646C46.0234 55.7307 48.351 59.3229 49.2191 63.5404L55.0113 58.709C54.4787 58.6428 53.8795 58.5766 53.2803 58.5766C43.0274 57.981 43.6266 49.5757 43.6266 49.5757H39.0994H34.5721C34.5721 49.5757 34.7053 51.7597 33.5735 53.9438C34.3058 54.6056 36.1034 55.5984 40.098 55.6646Z",
    fill: "#E1AC85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0087 29.2573C57.0087 41.3027 47.2885 53.9437 39.0329 53.9437C30.7774 53.9437 21.0571 41.3689 21.0571 29.2573C21.0571 17.212 29.113 10.2627 39.0329 10.2627C49.0195 10.2627 57.0087 17.212 57.0087 29.2573Z",
    fill: "#EABF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2803 58.5766C52.1485 58.5104 51.1499 58.378 50.2844 58.1133C43.5392 63.442 35.3252 63.442 27.8479 58.1133C26.9824 58.3118 25.9837 58.5104 24.8519 58.5766C14.5991 59.1722 7.80822 63.8712 8.00795 77.5712H39.0328H70.0577C70.3241 63.8712 63.5332 59.1722 53.2803 58.5766Z",
    fill: "#143A72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2817 21.1432C52.2817 21.1432 52.8809 26.3055 55.2777 28.4234C55.2777 28.4234 56.0101 31.0046 55.1446 33.7181C55.1446 33.7181 56.0101 33.0563 57.0753 32.8577C57.0753 32.8577 56.4761 28.4234 58.0739 28.2249C58.0739 28.2249 58.1405 21.408 56.4095 18.9592C54.6119 16.5766 52.2817 21.1432 52.2817 21.1432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9931 25.8157C19.326 16.5501 26.3166 11.4539 26.3166 11.4539C33.64 3.181 47.7544 5.82834 53.8129 10.2626C59.938 14.6969 63.5997 12.2481 63.5997 12.2481C55.2776 28.4631 31.6427 18.8665 31.6427 18.8665C31.6427 18.8665 26.7826 26.4114 22.788 28.2645C22.788 28.2645 21.7227 32.4341 22.5217 34.7505L21.1235 34.0225C21.1235 34.0225 20.9238 29.2573 19.3925 28.3969C19.3925 28.3969 18.9265 26.9408 18.9931 25.8157Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipped);
export default __webpack_public_path__ + "static/media/Clipped.5babf2096bdd9dd86af9108cd602509f.svg";
export { ForwardRef as ReactComponent };